'use strict';

if (typeof document != 'undefined') require('babel-polyfill');

var _ = require('lodash');
var Classnames = require('classnames');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var SuperAgent = require('superagent');

var Forms = require('../forms');
var Components = require('../components');
var Modal = require('../plugins/modal/');
var Moma = require('../plugins/legacy-moma/');

var Xfade = require('./Xfade.jsx');

var Actions = require('../store').Actions;
var Constants = require('../constants');
var Global = require('../global');

var Link    = ReactRouter.Link;
var Route   = ReactRouter.Route;
var Router  = ReactRouter.Router;
var History = ReactRouter.History;//require('history');

var LinkTile = require('../collections/linktile.jsx');  // When SPA transition is complete this will simplify
var CollectionLinkTile = LinkTile.CollectionLinkTile;
var MediaLinkTile      = LinkTile.MediaLinkTile;
var history  = Global.History;
var ParseAPI = Global.ParseAPI;
var Media = Components.Media;

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./designtool.scss');
}

// store context for clicking forward to 2nd or 3rd tab after previously visiting respective page
var _space = null;
var _layout = null;
var _finish = null;
var _control = false;

var Tabs = React.createClass({
    render: function() {
        var space = _.find(Payload.spaces, s => {
            return s.url == _space;
        });
        space = space ? space.name : null;
        var ix = 1;
        var classes = Classnames({
            'dt-tabs': true,
            'dt-refurbished': this.props.root == 'refurbished-workstations'
        });
        return (
            <div className={classes}>
                {this.props.root == 'modern-office-design' ?
                    <Tab ix        = {ix++}
                         type      = 'SPACE'
                         name      = {space}
                         selected  = {this.props.selected == 1}
                         link      = {[ this.props.root ]} />
                : null}
                
                <Tab ix        = {ix++}
                     type      = 'LAYOUT'
                     name      = {_layout}
                     selected  = {this.props.selected == 2}
                     link      = {[ this.props.root, _space ]} />
                
                <Tab ix        = {ix++}
                     type      = 'FINISH'
                     name      = {_finish ? _finish : null}
                     route     = 'finishes-item'
                     selected  = {this.props.selected == 3}
                     link      = {[ this.props.root, _space, _layout, _finish ]} />
            </div>
        );
    },
});

var Tab = React.createClass({
    render: function() {
        var content = (
            <div className='dt-tabHead-title'>
                {this.props.name ?
                    `${this.props.ix} / ${this.props.type}: ${this.props.name}`
                :
                    `${this.props.ix} / CHOOSE YOUR ${this.props.type}`
                }
            </div>
        );
        var classes = Classnames({
            'dt-tabHead': true,
            'dt-tabHead-selected': this.props.selected,
        });
        var valid = true;  // link is valid
        var link = this.props.link.reduce((prev, current, index, array) => {
            if (current) {
                return prev + '/' + current;
            }
            valid = false;
        });
        if (valid)
        {
            return (
                <Link className={classes} to={{
                    pathname: '/' + link,
                    state: {
                        scroll: false,
                }}}>
                    {content}
                </Link>
            );
        }
        else
        {
            return (
                <div className={classes}>
                    {content}
                </div>
            );
        }
    }
});


// ------------------------------------------------------------------------------

var SpaceTab = React.createClass({
    componentDidMount: function() {
        this.props.showFooter.requestChange(true);
    },
    render: function() {
        var spaces = Payload.spaces.map(function(space) {
            var labelClasses = Classnames({
                'linktile-sub': true,
                'linktile-sub-selected': space.url == _space,
            });
            return (
                <CollectionLinkTile key            = {space.id}
                                    target         = {'/' + this.props.params.root + '/' + space.url}
                                    urlkey         = {space.url.replace('+','')}
                                    alt            = {space.name}
                                    singlePageLink = {true}
                                    source         = 'designtool'>
                    {space.name}
                </CollectionLinkTile>
            );
        }.bind(this));
        return (
            <div>
                <Tabs root={this.props.params.root} location={this.props.location} selected={1} />

                <ToolIntro root={this.props.params.root} />

                <div className='dt-tabBody global-tiers'>
                    <div className='global-tiers-3'>
                        {spaces}
                    </div>
                </div>
            </div>
        );
    }
});

var ToolIntro = (props) => {
    var introTitle,
        introBody;

    if (props.root == 'modern-office-design') {
        introTitle = Payload.text['dyo.intro.dyo.title'];
        introBody = Payload.text['dyo.intro.dyo.body'];
    } else {
        introTitle = Payload.text['dyo.intro.refurbished.title'];
        introBody = Payload.text['dyo.intro.refurbished.body'];
    }
    return (
        <div className='dt-intro'>
            <h1 dangerouslySetInnerHTML={{ __html: introTitle }} />
            <div className='dt-intro-body' dangerouslySetInnerHTML={{ __html: introBody }} />
        </div>
    );
};
    
// ------------------------------------------------------------------------------

var LayoutTab = React.createClass({
    componentDidMount: function() {
        this.props.showFooter.requestChange(true);
    },
    componentWillMount: function() {
        var space = this.props.params.space.replace(/ /,'+');  // react-router 1.0 bug?
        if (_space != null && space != _space) {
            _layout = null;
            _finish = null;
        }
        _space = space;
    },

    render: function() {
        var url = this.props.params.space.replace(/ /,'+');  // react-router 1.0 bug?
        var space = _.find(Payload.spaces, { url: url });
        var layouts = space.layouts.map(layout => {
            var labelClasses = Classnames({
                'linktile-sub': true,
                'linktile-sub-selected': layout.name == _layout,
            });
            layout = _.assign(layout, {
                resize: {
                    width: 378,
                    height: 230,
                },
                url: '/' + this.props.params.root + '/' + space.url + '/' + layout.name,
                width: 378,
                height: 230,
            });
            return (
                <MediaLinkTile key    = {layout.groupID}
                               object = {layout}>
                    {layout.name}
                </MediaLinkTile>
            );
        }, this);
        return (
            <div>
                <Tabs root={this.props.params.root} location={this.props.location} selected={2} />
                <div className='dt-tabBody global-tiers'>
                    <div className='global-tiers-2'>
                        {layouts}
                    </div>
                </div>
            </div>
        );
    }
});

// ------------------------------------------------------------------------------

var FinishTab = React.createClass({
    mixins: [ LinkedStateMixin, History ],

    // statics: {
    //     willTransitionTo: function(transitions, params, query) {
    //         _space = params.space;
    //         _layout = params.layout;
    //         _finish = params.finish;
    //     }
    // },

    getInitialState: function() {
        return {
            ix: 0,
            items: null,
            slide: null,
        };
    },
    componentDidMount: function() {
        _space = this.props.params.space.replace(/ /,'+');
        _layout = this.props.params.layout;
        _finish = this.props.params.finish;

        this.props.showFooter.requestChange(false);

        var _this = this;
        var query = {
            group: this.props.params.layout
        };
        SuperAgent
            .get('/modern-office-design.json')
            .query(query)
            .end(function(err, res) {
                var r = ParseAPI(query, err, res);
                if (!r) {
                    return;
                }
                _this.setState({
                    ix:         0,
                    items:      r.items,
                    slide:      r.items[0],
                    desc:       r.desc,
                    schematics: r.schematics,
                    text:       r.text,
                });
                FinishTab.desc = r.desc;
                _finish = _this.props.params.finish;
                if (_finish === undefined) {
                    _finish = r.items[0].name;
                }
                
                // Start the gallery off on the right slide. Don't use moma.navigateTo because it breaks IE9 (#113)
                _this.refs.moma.setState({
                    ix: _.findIndex(r.items, function(s) {
                        return s.name == _finish;
                    })
                });
                var slide = _.find(r.items, function(s) {
                    return s.name == _finish;
                });
                _this.setState({
                    slide: slide
                });
                _this.props.showFooter.requestChange(true);

                Actions.viewedItem(_.assign(slide, {
                    // First DYO finish is shown when navigating to /root/space/layout from /root/space/ (/finish at end is omitted)
                    // e.g. from /modern-office-design/Modular+Workstations to /modern-office-design/Modular+Workstations/WS-3-D
                    // shows /modern-office-design/Modular+Workstations/WS-3-D/WS-3D-22
                    alternateURL: `/${_this.props.params.root}/${_space}/${_layout}`,
                }));
            });
    },
    render: function() {
        if (!this.state.items) {
            return null;
        }
        var proportion = 0.43396226415094;  //   230 / (460 + 70)   230 = 600 / 1000 * (1150 / 3)
                                            //                      460 = (1150px / 3 * 2) / 1000px * 600px   = $heroHeight
                                            //                       70 = $toolbarHeight

        if (this.props.children) {
            var childrenProps = {
                desc: this.state.desc,
                slide: this.state.slide
            };
            var children = React.cloneElement(this.props.children, childrenProps);
        }

        return (
            <div>
                <Tabs root={this.props.params.root} location={this.props.location} selected={3} />
                <div className='dt-tabBody dt-finishes'>
                    <div className='dt-hero'>
                        <div className='dt-hero-img'>
                            <Xfade src={Payload.release.media + this.state.slide.filename} />
                        </div>
                        <FinishToolbar items  = {this.state.items}
                                       desc   = {this.state.desc}
                                       text   = {this.state.text}
                                       params = {this.props.params} />
                        {children}
                    </div>
                    <FinishGallery gallery        = {this.state.items}
                                   size           = {523}
                                   proportion     = {proportion}
                                   orientation    = 'vertical'
                                   loop           = {true}
                                   finish         = {this.linkState('slide')}
                                   ref            = 'moma'
                                   root           = {this.props.params.root} />
                </div>
            </div>
        );
    }
});

var FinishToolbar = React.createClass({
    addToProject: function() {
        var item = _.find(this.props.items, item => {
            return item.name == _finish;
        });
        item.space = _.find(Payload.spaces, s => {return s.url == _space; });
        Actions.addItem(_.assign(item, {
            layout: _layout,
        }), 'concept', 1);

        // Not using the 'Add to Quote' dialog
        // this.refs.continueDialog.open(item);

        // Instead just redirect directly to Project page
        window.location = '/your-project';
    },
    render: function() {
        return (
            <div className='dt-toolbar'>
                <div className='dt-toolbar-left'>
                    {this.props.desc ?
                        <FinishControl action='story' label='MORE INFO' params={this.props.params} />
                    : null}
                    <FinishControl action='zoom' label='ZOOM' params={this.props.params} />
                </div>
                <div className='dt-toolbar-right'>
                    <Components.Howto text={Payload.text['dyo.howto']} />
                    <Forms.Button onClick={this.addToProject} label='ADD TO YOUR QUOTE' />
                    {/*<Components.ContinueDialog type='dyo' ref='continueDialog' />*/}
                </div>
            </div>
        );
    },
});

var FinishControl = React.createClass({
    mixins: [ History ],

    getInitialState: function() {
        return {
            hover: false,
            open: false,
        };
    },
    onMouseOver: function(e, o) {
        this.setState({ hover: true });
    },
    onMouseOut: function() {
        this.setState({ hover: false });
    },
    onClick: function() {
        if (_control) {
            this.history.replaceState(null, `/${this.props.params.root}/${_space}/${_layout}/${_finish}/`);
        } else {
            this.history.replaceState(null, `/${this.props.params.root}/${_space}/${_layout}/${_finish}/${this.props.action}`);
        }
        _control = !_control;
    },
    render: function() {
        var label = null;
        if (this.state.hover) {
            label = (
                <div className='dt-control-label'>
                    <span>{this.props.label}</span>
                </div>
            );
        }
        return (
            <div className='dt-control' onMouseOut={this.onMouseOut} onClick={this.onClick}>
                {label}
                <img src={Constants.static + 'images/designtool/' + this.props.action + '.png'} onMouseOver={this.onMouseOver} />
            </div>
        );
    },
});

var FinishViewStory = React.createClass({
    render: function() {
        return (
            <div className='dt-hero-desc'>
                <h1>{this.props.slide.name}</h1>
                {this.props.desc}
            </div>
        );
    }
});
var FinishViewPlan = React.createClass({
    render: function() {
        return (
            <div className='dt-hero-desc'>
                hello plan
            </div>
        );
    }
});
var FinishViewZoom = React.createClass({
    mixins: [ History ],

    modalDidClose: function() {
        _control = false;
        this.history.replaceState(null, `/${this.props.params.root}/${_space}/${_layout}/${_finish}/`);
    },
    render: function() {
        return (
            <Modal onClose={this.modalDidClose} width={1000} height={600} startOpen={true}>
                <Media media={this.props.slide} width={1000} />
            </Modal>
        );
    }
});

var FinishGallery = React.createClass({
    mixins: [ Moma, History ],

    slideWillChange: function(ix, slide) {
        this.props.finish.requestChange(slide);
        _finish = slide.name;

        var path = `/${this.props.root}/${_space}/${_layout}/${_finish}`;
        this.history.replaceState({ scroll: false }, path);

        Actions.viewedItem(slide);
    },
    slideContent: function(slide) {
        var c = Classnames({
            'dt-cursor': this.props.finish.value.id == slide.id,
        });
        return (
            <Media media={slide} className={c} />
        );
    }
});

// ------------------------------------------------------------------------------

var DesignTool = React.createClass({
    mixins: [ LinkedStateMixin ],
    
    getInitialState: function() {
        return {
            // Don't show flash of footer before body images load
            showFooter: isNode,
        };
    },
    render: function() {
        return (
            <div>
                <Components.Header tab='designtool' landing='standard' />
                <div>
                    {React.cloneElement(this.props.children, { showFooter: this.linkState('showFooter') })}
                    {this.state.showFooter && !isNode ?
                        <Components.Footer />
                    : null}
                </div>
            </div>
        );
    }
});

var routes = (
    <Route component={DesignTool}>
        <Route path='/:root'                         component={SpaceTab}        onEnter={Global.GAPageview} />
        <Route path='/:root/:space'                  component={LayoutTab}       onEnter={Global.GAPageview} />
        <Route path='/:root/:space/:layout'          component={FinishTab}       onEnter={Global.GAPageview} />
        <Route path='/:root/:space/:layout/:finish'  component={FinishTab}       onEnter={Global.GAPageview} />
        <Route path='/:root/:space/:layout/:finish/' component={FinishTab}>
            <Route path='story'                      component={FinishViewStory} />
            <Route path='plan'                       component={FinishViewPlan} />
            <Route path='zoom'                       component={FinishViewZoom} />
        </Route>
    </Route>
);

if (isNode) {
    global.routes = routes;
} else {
    var dom = (
        <Router history={history}>
            {routes}
        </Router>
    );
    ReactDOM.render(dom, document.getElementById('designtool'));
}



// WEBPACK FOOTER //
// ./src/designtool/designtool.jsx